module.exports = __webpack_public_path__ + "static/media/RR_H_03.54e9b0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/heads/RR_H_03.png
// module id = 138
// module chunks = 0